var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiversityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    rx: 10,
    fill: "#CF375D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 48C57.1826 48 60.2348 46.7357 62.4853 44.4853C64.7357 42.2348 66 39.1826 66 36C66 32.8174 64.7357 29.7652 62.4853 27.5147C60.2348 25.2643 57.1826 24 54 24C50.8174 24 47.7652 25.2643 45.5147 27.5147C43.2643 29.7652 42 32.8174 42 36C42 39.1826 43.2643 42.2348 45.5147 44.4853C47.7652 46.7357 50.8174 48 54 48ZM34.5 57C36.4891 57 38.3968 56.2098 39.8033 54.8033C41.2098 53.3968 42 51.4891 42 49.5C42 47.5109 41.2098 45.6032 39.8033 44.1967C38.3968 42.7902 36.4891 42 34.5 42C32.5109 42 30.6032 42.7902 29.1967 44.1967C27.7902 45.6032 27 47.5109 27 49.5C27 51.4891 27.7902 53.3968 29.1967 54.8033C30.6032 56.2098 32.5109 57 34.5 57ZM81 49.5C81 51.4891 80.2098 53.3968 78.8033 54.8033C77.3968 56.2098 75.4891 57 73.5 57C71.5109 57 69.6032 56.2098 68.1967 54.8033C66.7902 53.3968 66 51.4891 66 49.5C66 47.5109 66.7902 45.6032 68.1967 44.1967C69.6032 42.7902 71.5109 42 73.5 42C75.4891 42 77.3968 42.7902 78.8033 44.1967C80.2098 45.6032 81 47.5109 81 49.5ZM54 51C57.9782 51 61.7936 52.5804 64.6066 55.3934C67.4196 58.2064 69 62.0218 69 66V84H39V66C39 62.0218 40.5804 58.2064 43.3934 55.3934C46.2064 52.5804 50.0218 51 54 51ZM33 66C33 63.921 33.3 61.914 33.864 60.018L33.354 60.06C30.7826 60.3423 28.406 61.5639 26.6798 63.4905C24.9536 65.4172 23.9993 67.9132 24 70.5V84H33V66ZM84 84V70.5C84.0003 67.8251 82.9798 65.2509 81.1466 63.3029C79.3135 61.3549 76.806 60.18 74.136 60.018C74.697 61.914 75 63.921 75 66V84H84Z",
    fill: "#ECB32C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiversityIcon);
export default __webpack_public_path__ + "static/media/diversity-icon.0f1285907d2afe6afa4d38f82751dcba.svg";
export { ForwardRef as ReactComponent };